import { inject, Pipe, PipeTransform } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HubspotConfigLookupService } from '../services/hubspot-config-lookup.service';

@Pipe({
  name: 'hubspotDistributorName',
  standalone: true,
})
export class HubspotDistributorNamePipe implements PipeTransform {
  private readonly lookupService = inject(HubspotConfigLookupService);

  transform(distributorId: string | null | undefined): Observable<string> {
    if (!distributorId) {
      return of('');
    }

    return from(this.lookupService.getDistributors()).pipe(
      map((distributors) => {
        const distributor = distributors.find((d) => d.value === distributorId);
        return distributor ? distributor.label : distributorId;
      }),
    );
  }
}

